import type { ProductPreOrderSettings } from '@spa/components/product-info/ProductInfoProductTypes';
import { StateCartEntry } from '@spa/lib/store/carts/CartsState';

export const isProductCompatibleWithCarts = (
  homeDeliveryCartEntries: ReadonlyArray<StateCartEntry>,
  collectAtStoreCartEntries: ReadonlyArray<StateCartEntry>,
  productCode: string,
  preOrderSettings: ProductPreOrderSettings | null
): boolean => {
  const isPreorderProduct: boolean = preOrderSettings !== null && preOrderSettings.isActive;
  const cartEntries: ReadonlyArray<StateCartEntry> = [
    ...homeDeliveryCartEntries,
    ...collectAtStoreCartEntries
  ];
  const isCartEmpty: boolean = cartEntries.length === 0;

  const preorderProductInCart: StateCartEntry | undefined = cartEntries.find(
    ({ product: { preOrderSettings: entryPreOrderSettings } }: StateCartEntry): boolean =>
      !!entryPreOrderSettings && entryPreOrderSettings.isActive
  );
  const isTheSamePreOrderProductFromCart: boolean =
    productCode === preorderProductInCart?.product.code;

  return (
    !isCartEmpty &&
    ((!isPreorderProduct && !!preorderProductInCart) ||
      (isPreorderProduct && (!isTheSamePreOrderProductFromCart || !preOrderSettings?.unlimited)))
  );
};

export default isProductCompatibleWithCarts;
